const breadCrumbSchema = (breads) => {
  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList'
  };
  schema.itemListElement = breads
    .filter((bread) => bread.name && bread.url)
    .map((bread, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: bread.name,
      item: bread.url
    }));

  return schema;
};

export default breadCrumbSchema;
